var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('h5',{staticClass:"branch-name"},[_vm._v(_vm._s(_vm.branchName))])])}
var staticRenderFns = []

export { render, staticRenderFns }